import SignIn from '../../Components/SignIn';
import {connect} from 'react-redux';
import {signIn, resendOTP} from '../../modules/auth';

const mapStateToProps = (state, ownProps) => {
  const {auth: {authenticated, loading, error = ''} = {}} = state;
  return {
    isAuthenticated: authenticated,
    isLoading: loading,
    error,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (data) => dispatch(signIn(data)),
    resendOTP: (data) => dispatch(resendOTP(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
